import { Component, EventEmitter, Output, signal, ViewChild } from '@angular/core';
import { RecaptchaComponent } from 'ng-recaptcha';
import { DialogComponent } from '../../dialog/dialog.component';

@Component({
  selector: 'opac-recaptcha-dialog',
  templateUrl: './recaptcha-dialog.component.html',
  styleUrls: ['./recaptcha-dialog.component.scss']
})
export class RecaptchaDialogComponent {
  @ViewChild('captcha') captcha!: RecaptchaComponent;
  @ViewChild(DialogComponent) dialog!: DialogComponent;

  @Output() errored = new EventEmitter<void>();
  @Output() resolved = new EventEmitter<string>();

  readonly isOpen = signal<boolean>(false);

  openDialog() {
    this.isOpen.set(true);
    this.dialog.openDialog();
  }

  closeDialog() {
    this.isOpen.set(false);
    this.dialog.closeDialog();
  }

  handleError() {
    this.errored.emit();
    throw new Error(`reCAPTCHA error encountered`);
  }
}
